import { SubscriptionPlan } from '../types'

const CHECKOUT_PLAN_STORAGE_KEY = 'selected_checkout_plan'

export function saveSelectedCheckoutPlan(planRef: string | number) {
  localStorage.setItem(CHECKOUT_PLAN_STORAGE_KEY, String(planRef))
}

export function getSelectedCheckoutPlanRef(): string | null {
  const value = localStorage.getItem(CHECKOUT_PLAN_STORAGE_KEY)
  return value || null
}

export function getSelectedCheckoutPlanId(): number | null {
  const value = getSelectedCheckoutPlanRef()
  if (!value) return null
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

export function clearSelectedCheckoutPlan() {
  localStorage.removeItem(CHECKOUT_PLAN_STORAGE_KEY)
}

export function getBillingCycleLabel(durationDays: number): string {
  if (durationDays === 30) return 'Monthly'
  if (durationDays === 90) return 'Quarterly'
  if (durationDays === 365) return 'Yearly'
  return `${durationDays} days`
}

export function getPlanFeatureList(plan: Pick<SubscriptionPlan,
  'core_details' |
  'email_delivery' |
  'telegram_delivery' |
  'whatsapp_support' |
  'priority_support'
>): string[] {
  const list: string[] = []
  try {
    if (plan.core_details) {
      const parsed = JSON.parse(plan.core_details)
      if (Array.isArray(parsed)) {
        parsed.forEach(p => list.push(p.value))
      }
    }
  } catch {}
  if (plan.email_delivery) list.push('Email delivery')
  if (plan.telegram_delivery) list.push('Telegram alerts')
  if (plan.whatsapp_support) list.push('WhatsApp support')
  if (plan.priority_support) list.push('Priority support')
  return list
}
